const NAV_VARIANTS = {
  DROPDOWN: 'dropdown',
  GLOBAL: 'global'
};

export { NAV_VARIANTS };
